<template>
  <div>
    <Form :description-title="'Atualize os dados da sua unidade'">
      <Create
        @click="updateUnidade()"
        :icon="PhBuildingApartment"
        :label="'Atualizar'"
      />
    </Form>
  </div>
</template>

<script setup>
import Create from "@/components/Buttons/Create.vue";
import Form from "../components/UnidadeForm.vue";
import RcdService from "../service/rcd.service";
import * as yup from "@/validator";
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField,
} from "@/helpers/formFieldsHandler";
import { PhBuildingApartment } from "@phosphor-icons/vue";
import { showToast as toast } from "@/helpers/UseToasts";
import { dataRcd } from "../store";
import { storeApp } from "@/store";
import { ref } from "vue";

const store = dataRcd.state;
const appStore = storeApp.state;
const id = ref(store.unidadeForm.id);

const schema = yup.object().shape({
  unidadeForm: yup.object().shape({
    unidade: yup.string().required("Informe a unidade").label("Unidade"),
    cidade: yup
      .string()
      .required("Informe a cidade da unidade")
      .label("Cidade"),
    estado: yup.string().required("Estado da unidade").label("Estado"),
  }),
});

async function updateUnidade() {
  appStore.loading = true;

  cleanAllFormFields();

  const validate = await validateFormField(schema, store);

  if (validate && validate.length > 0) {
    setFormFieldsError(validate);
    appStore.loading = false;
    return;
  }

  await RcdService.updateUnidade(store.unidadeForm, id.value)
    .then((res) => {
      appStore.loading = false;

      if (res.data.success) {
        dataRcd.dispatch("setUnidades", res.data.unidades);

        return toast("Sucesso", res.data.message, "success");
      }
    })
    .catch((err) => {
      appStore.loading = false;

      if (err?.response?.data?.error) {
        return toast("Aviso", err.response.data.message, "error");
      }

      return toast("Aviso", "Algo deu errado ao cadastrar unidade", "error");
    });
}
</script>
